export const appConfig = {
  appName: "mesh-clap-track",
  storagePrefix: "mesh-clap-track",
  description:
    "Peer-to-peer mesh: real claps from your microphone become a synced drum loop. Each phone is a different drum sound.",
  accentHex: "#A45EFF",
  version: __APP_VERSION__,
  commit: __GIT_COMMIT__,
  repositoryUrl: "https://github.com/baditaflorin/mesh-clap-track",
  pagesUrl: "https://baditaflorin.github.io/mesh-clap-track/",
  signalingUrl:
    (import.meta.env.VITE_WEBRTC_SIGNALING as string | undefined) ?? "wss://turn.0docker.com/ws",
  turnTokenUrl:
    (import.meta.env.VITE_TURN_TOKEN_URL as string | undefined) ??
    "https://turn.0docker.com/credentials",
  paypalUrl: "https://www.paypal.com/paypalme/florinbadita",
} as const;
